import { render, staticRenderFns } from "./SuspensionCare.vue?vue&type=template&id=4ab03de5"
import script from "./SuspensionCare.vue?vue&type=script&lang=js"
export * from "./SuspensionCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports